import { type MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

import { Stack, Container, Button } from "@mui/material";

import { Footer } from "~/components/Footer";
import { Header } from "~/components/Header";
import { ServiceHeroBanner } from "~/components/HeroBanner";
import { AutoCompleteInput } from "~/components/Home/AutoCompleteInput";
import { ImageSection } from "~/components/ImageSection";
import { CardSection } from "~/components/Service/CardSection";
import { ColoredSection } from "~/components/Service/ColoredSection";
import { FaqSection } from "~/components/Service/FaqSection";
import { GoogleSection } from "~/components/Service/GoogleSection";
import { HappeningsSection } from "~/components/Service/HappeningsSection";
import { TextSection } from "~/components/Service/TextSection";
import { TimelineSection } from "~/components/Service/TimelineSection";
import { LitleSmileSvg } from "~/components/SmileSvg";
import safeLink from "~/components/safeLink";

export default () => {
  const {
    heroBanner,
    cta,
    agency,
    advantageCards,
    law,
    locTimeline,
    happenings,
    google,
    faq,
    beachBanner,
  } = useLoaderData<typeof loader>();

  return (
    <>
      <Header
        cta={
          <Button variant="contained" size="small" {...safeLink(cta.url)}>
            {cta.label}
          </Button>
        }
      />
      <ServiceHeroBanner
        backgroundColor="gris"
        image={{
          ...heroBanner.image,
          decorationRight: true,
          decorationSecondary: true,
        }}
        heading={heroBanner.heading}
        subheading={heroBanner.subheading}
        cta={
          <AutoCompleteInput
            ctaLabel={cta.label}
            ctaColor="coral"
            url="/formulaire"
          >
            <input type="hidden" name="step" value="0" />
            <input type="hidden" name="ownership" value="owner" />
          </AutoCompleteInput>
        }
      />
      <TextSection {...agency} />
      <CardSection cards={advantageCards} />
      <ColoredSection {...law} color={(theme) => theme.palette.grey[100]} />
      <TimelineSection
        ctaLabel={locTimeline.button.text}
        timeline={locTimeline.timeline}
        title={locTimeline.title}
        url={cta.url}
      />
      <HappeningsSection {...happenings} />
      <GoogleSection {...google} />
      <FaqSection {...faq} />
      <Container component="section">
        <Stack py={10} direction="row" justifyContent="center">
          <LitleSmileSvg />
        </Stack>
      </Container>
      <ImageSection
        title={beachBanner.title}
        buttonLabel={beachBanner.button.text}
        url={cta.url}
        img={beachBanner.img}
      />
      <Footer />
    </>
  );
};

export const loader = async () => {
  return import("~/data/pages/location-courte-duree").then(
    ({ pageData }) => pageData,
  );
};
export const meta: MetaFunction<typeof loader> = ({
  data: { title, description },
}) => ({
  title,
  description,
});
